import { backgroundTasksAPI } from "@/services/api.services";

export async function enqueueBackgroundTaskAndPoll(
    params,
    pollInterval = 1000,
    maxRetries = 10,
    fileAttachment = null
) {
    const enqueueResult = fileAttachment
        ? await backgroundTasksAPI.enqueueBackgroundTaskWithFileAttachment(params, fileAttachment)
        : await backgroundTasksAPI.enqueueBackgroundTask(params);
    const taskId = enqueueResult.id;
    let retries = 0;
    let backgroundTask = null;

    while (retries < maxRetries) {
        backgroundTask = await backgroundTasksAPI.fetchBackgroundTaskById(taskId);
        const taskStatus = backgroundTask.status;

        if (taskStatus === "completed" || taskStatus === "failed") {
            return backgroundTask;
        }

        await new Promise((resolve) => setTimeout(resolve, pollInterval));
        retries++;
    }

    return backgroundTask;
}
